module.exports = __webpack_public_path__ + "img/respect-logo-white-intro.a8ba8468.svg";